import React from 'react'

class Footer extends React.Component {
  formatDate(date) {
    var monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    var day = date.getDate()
    var monthIndex = date.getMonth()
    var year = date.getFullYear()

    return day + ' ' + monthNames[monthIndex] + ' ' + year
  }

  render() {
    var x = new Date()
    if (typeof window !== 'undefined') {
      x = new Date(document.lastModified)
    }
    return (
      <div id="footer">
        <div className="inner">
          <ul className="copyright">
            <li>&copy; Siwei Fu</li>
            <li>Last update: {this.formatDate(x)}</li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js